import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PACaricaFatturaComponent } from './pa-carica-fattura';


// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-carica-fattura', {
            url: '/pa-carica-fattura',
            ncyBreadcrumb: {
                label: 'Carica Fattura',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Carica fattura XML'
            },
            'views': {
                'homeContent': {
                    template: '<pa-carica-fattura flex="100"></pa-carica-fattura>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PACaricaFatturaModule: string = ng
    .module('pa-carica-fattura', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paCaricaFattura', PACaricaFatturaComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-carica-fattura/pa-carica-fattura.module.ts